import { CountryActions, countryTypes } from '../types/contryTypes';
import { Country } from '@/types/country/country';

interface CountryReducerInitialState {
  countries: Country[];
  loading: boolean;
}

const initialState: CountryReducerInitialState = {
  countries: [],
  loading: false,
};

export const countryReducer = (state = initialState, action: CountryActions) => {
  switch (action.type) {
    case countryTypes.startLoadingCountries:
      return { ...state, loading: true };
    case countryTypes.finishLoadingCountries:
      return { ...state, loading: false };
    case countryTypes.countriesLoad:
      return { ...state, countries: action.payload };
    default:
      return state;
  }
};
